import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export type TranslationDataInEditMode = { translationId: number; userName: string };

export const initialState = {
    translationsInEditMode: [] as TranslationDataInEditMode[],
    lockedTranslationsLoaded: false,
};

const translationEditorSlice = createSlice({
    name: 'translationEditor',
    initialState,
    reducers: {
        addTranslationsInEditMode: (state, { payload }: PayloadAction<TranslationDataInEditMode[]>) => {
            state.translationsInEditMode = [...state.translationsInEditMode, ...payload];
        },
        removeTranslationFromEditMode: (state, { payload }: PayloadAction<{ translationId: number }>) => {
            state.translationsInEditMode = [
                ...state.translationsInEditMode.filter(({ translationId }) => translationId !== payload.translationId),
            ];
        },
        lockedTranslationsLoaded: (state, { payload }: PayloadAction<boolean>) => {
            state.lockedTranslationsLoaded = payload;
        },
    },
});

export default translationEditorSlice.reducer;

export const translationEditorActions = translationEditorSlice.actions;

export type TranslationEditorState = typeof initialState;
